/**
 * The unsaved-changes askers of the open drawers, as a stack. A drawer pushes its asker while open and removes THAT asker when it
 * closes, wherever it sits, so a drawer opened over another (Quick adjust over a milestone) and closed again leaves the one
 * beneath still asked. `ask` goes top-down through every asker and resolves false as soon as one says keep.
 */
export type Asker = () => Promise<boolean>;

export function createAskerStack() {
  const askers: Asker[] = [];
  return {
    push(asker: Asker): void {
      askers.push(asker);
    },
    remove(asker: Asker): void {
      const at = askers.lastIndexOf(asker);
      if (at >= 0) askers.splice(at, 1);
    },
    async ask(): Promise<boolean> {
      for (const asker of [...askers].reverse()) if (!(await asker())) return false;
      return true;
    },
    get size(): number {
      return askers.length;
    },
  };
}
